import TransferOrganizationForm from './TransferOrganizationForm';

export default TransferOrganizationForm;
